import { Element, Component, Host, h, Prop, Event, EventEmitter, Watch } from '@stencil/core';
import ThreeDIcon from '../../../icons/3d';
import AudioIcon from '../../../icons/audio';
import GreenCheck from '../../../icons/check-green';
import ErrorIcon from '../../../icons/error';
import ImageIcon from '../../../icons/image';
import VideoIcon from '../../../icons/video';

@Component({
  tag: 'zpr-ml-uploading-item',
  styleUrl: 'zpr-ml-uploading.scss'
})
export class ZprMlUploadingItem {
  private _overallProgress = 0

  @Element() el: Element;

  @Prop({ mutable:true }) uid:string;
  @Prop({ mutable:true }) type:string;
  @Prop({ mutable:true }) filename:string;
  @Prop({ mutable:true }) status:string;
  @Prop({ mutable:true }) progress:number;

  @Event({ eventName: 'zml:missingfiles:show' }) showMissingFiles: EventEmitter<string>;

  _getMediaIcon(mediaType:string){
    const regex = /(video)|(image)|(audio)/g;
    const typeMatch = mediaType.match(regex);

    if(typeMatch){
      const type = typeMatch[0]
      if(type == 'image') return ( <ImageIcon></ImageIcon> )
      if(type == 'audio') return ( <AudioIcon></AudioIcon> )
      if(type == 'video') return ( <VideoIcon></VideoIcon> )
    }
    return (<ThreeDIcon></ThreeDIcon>)
  }

  missingFilesBtnClick() {
    this.showMissingFiles.emit(this.uid)
  }

  @Watch('progress')
  setOverallProgress() {
    // first 50% for upload
    if (this.status === 'uploading') {
      this._overallProgress = Math.ceil(this.progress * 50 / 100)
    } else {
      this._overallProgress = 50 + Math.ceil(this.progress * 50 / 100)
    }
  }

  render() {
    return (
      <Host class="flex column preview-row">
        <div class="flex f1 acenter uploading-row">
          <div class="progress-file-icon">
            { this._getMediaIcon(this.type)}
          </div>
          <div class="progress-file f1">
            <p>{this.filename}</p>
            { this.status == 'error' ? (
              this.type == 'gltf' ? (
                <button type="button" class="btn btn-link" onClick={this.missingFilesBtnClick.bind(this)}>Show missing files</button>
              ):(
                <span class="failed">Upload failed</span>
              )
            ):null}
          </div>
          <div class="progress-icon">
            {this.status == "error" ? (
              <ErrorIcon></ErrorIcon>
            ):(
              this.status == 'completed' || this._overallProgress == 100 ? (
                <GreenCheck></GreenCheck>
              ):(
                <zpr-progress-ring progress={this._overallProgress}></zpr-progress-ring>
              )
            )}
          </div>
        </div>
      </Host>
    );
  }
}
